import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Injector, Input, Output, Renderer2 } from '@angular/core';
import { CarouselModule as PCarouselModule } from 'primeng/carousel';
import { CarouselOrientation } from '../../enums/common.enum';
import { CommonService } from '../../services/common.service';

@Component({
  standalone: true,
  imports: [CommonModule, PCarouselModule],
  selector: 'app-image-overlay',
  templateUrl: './image-overlay.component.html',
  styleUrls: ['./image-overlay.component.scss']
})
export class ImageOverlayComponent {
  @Input() images: any = {};
  @Input() showIndicators: boolean = false;
  @Input() showNavigators: boolean = false;
  @Input() circular: boolean = false;
  @Input() autoplayInterval: number = 0;
  @Input() orientation: string = CarouselOrientation.HORIZONTAL;
  @Input() page: number = 0;
  @Output() SelectedIndexEmit = new EventEmitter<void>();
  isBrowser: boolean;
  private readonly cms: CommonService;
  display = false;

  constructor(
    private renderer: Renderer2,
    private readonly injector: Injector
  ) {
    this.cms = this.injector.get(CommonService);
    this.isBrowser = this.cms.isBrowser;
  }

  openOverlay(): void {
    this.display = true;
    if (this.isBrowser) {
      this.renderer.setStyle(document.body, 'overflow', 'hidden');
    }
  }
  onCarouselPageChange(event: any): void {
    if (event?.page) {
      this.SelectedIndexEmit.emit(event.page)
    }
  }
  closeOverlay(): void {
    this.display = false;
    if (this.isBrowser) {
      this.renderer.setStyle(document.body, 'overflow', 'auto');
    }
  }
}
